import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Form, Space } from 'antd';

export default function TinyInput({
  label, name, form, errorMessage, setValueName = null,
}) {
  const formValue = Form.useWatch(setValueName || name, form);

  const editorRef = useRef(null);
  const [isInitialValueSet, setIsInitialValueSet] = useState(false);
  const [isTinySet, setIsTinySet] = useState(false);

  const handleChange = () => {
    form.setFieldValue(setValueName || name, editorRef.current.getContent());
  };

  useEffect(() => {
    const value = form.getFieldValue(setValueName || name);
    if (
      editorRef?.current?.initialized
        && !isInitialValueSet
        && form.getFieldValue(setValueName || name) !== undefined) {
      // eslint-disable-next-line no-unused-expressions
      value
      && editorRef.current.setContent(value);
      setIsInitialValueSet(true);
    }
  }, [isTinySet]);

  return (
    <Space direction="vertical" style={{ width: '100%', marginBottom: '20px' }}>
      <Form.Item style={{ display: 'none' }} label={label} name={name} validateStatus={errorMessage && 'error'} help={errorMessage} />
      <div className="ant-col ant-form-item-label css-dev-only-do-not-override-yp8pcc">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label
          title={label}
        >
          {label}
        </label>
      </div>
      <Editor
        apiKey="px7hx2ze18cq0db8cpe6cgw68bxa4tor916pazote27482pm"
        onInit={(evt, editor) => {
          editorRef.current = editor;
          setIsTinySet(true);
        }}
        value={formValue || ''}
        init={{
          height: 500,
          menubar: false,
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount',
          ],
          toolbar: 'undo redo | blocks | '
                + 'bold italic forecolor | alignleft aligncenter '
                + 'alignright alignjustify | bullist numlist outdent indent | '
                + 'removeformat | help',
        }}
        onEditorChange={handleChange}
      />
      <div className="ant-form-item-explain ant-form-item-explain-connected css-dev-only-do-not-override-yp8pcc" role="alert">
        <div className="ant-form-item-explain-error" style={{ color: '#ff4d4f' }}>{errorMessage}</div>
      </div>
    </Space>
  );
}
